export type AppleIdentityResult = {
  idToken: string
  nonce: string
  name?: string
}

const createNonce = (size = 32): string => {
  const chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'
  const random = new Uint8Array(size)
  window.crypto.getRandomValues(random)

  return Array.from(random)
    .map((value) => chars[value % chars.length])
    .join('')
}

export const signInWithAppleIdentity = async (): Promise<AppleIdentityResult> => {
  const clientId = import.meta.env.VITE_APPLE_CLIENT_ID?.trim()
  const redirectUri = import.meta.env.VITE_APPLE_REDIRECT_URI?.trim()

  if (!clientId || !redirectUri) {
    throw new Error('Apple client id or redirect URI is not configured.')
  }

  const appleAuth = window.AppleID?.auth
  if (!appleAuth) {
    throw new Error('Apple Sign In SDK is not available.')
  }

  const nonce = createNonce()

  appleAuth.init({
    clientId,
    redirectURI: redirectUri,
    scope: 'name email',
    usePopup: true,
    nonce
  })

  const response = await appleAuth.signIn()
  const idToken = response.authorization?.id_token

  if (!idToken) {
    throw new Error('Apple did not return an ID token.')
  }

  const firstName = response.user?.name?.firstName?.trim()
  const lastName = response.user?.name?.lastName?.trim()
  const fullName = [firstName, lastName].filter(Boolean).join(' ').trim()

  return {
    idToken,
    nonce,
    ...(fullName ? { name: fullName } : {})
  }
}
